/**
 * BottomSheet 스타일
 * @description `<dialog>` 기본 위치(가운데)를 풀고 아래에 붙인다. 패널 폭은 앱 화면 폭(480)에
 *   맞춘다 — 넓은 화면에서 시트가 화면 전체로 퍼지면 손이 닿는 자리가 아니다.
 */
export const bottomSheetStyles = {
  dialog: [
    "m-0 max-h-none w-full max-w-none bg-transparent p-0",
    "mt-auto backdrop:bg-[var(--fw-color-effect-scrim)]",
    "open:flex open:flex-col open:justify-end",
  ].join(" "),
  panel:
    "mx-auto flex w-full max-w-[480px] flex-col rounded-t-[var(--fw-radius-xl)] bg-[var(--fw-color-surface-neutral-primary)] px-[var(--fw-space-inset-screen)] pb-[var(--fw-space-inset-xl)]",
  grabberRow: "flex justify-center py-[var(--fw-space-inset-md)]",
  grabber:
    "h-1 w-10 rounded-[var(--fw-radius-full)] bg-[var(--fw-color-border-disabled)]",
  body: "min-h-0 flex-1 overflow-y-auto",
};
